import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { WhatYouGetSection } from './components/WhatYouGetSection';
import { BonusesSection } from './components/BonusesSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-[#FAFAFF] font-sans selection:bg-[#E0E7FF] selection:text-[#312E81]" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <ProblemSection data-id="element-3" />
        <WhatYouGetSection data-id="element-4" />
        <BonusesSection data-id="element-5" />
        <TestimonialsSection data-id="element-6" />
        <FAQSection data-id="element-7" />
        <CTASection data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}